
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $7750d3c6c91e1a96$exports = {};
$7750d3c6c91e1a96$exports = import.meta.resolve("aKfoT");


function $38859a0fd15e9552$export$42cfbb80f7861e77() {
    return `
    <nav class="navbar navbar-expand-lg navbar-dark bg-transparent fixed-top py-2 px-2" style="--bs-bg-opacity: .2;">
      <div class="container">

        <a class="navbar-brand d-flex align-items-center" href="#">
            <img src="${0, (/*@__PURE__*/$parcel$interopDefault($7750d3c6c91e1a96$exports))}" alt="Logo" height="50" class="me-2">
            <span class="fw-bold"><span style="color:#E50914;">Hunter</span> Cuan</span>
        </a>

        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarNav">
          <ul class="navbar-nav ms-auto align-items-lg-center">

            <li class="nav-item">
              <a class="nav-link" href="#">Home</a>
            </li>

            <li class="nav-item">
              <a class="nav-link" href="#layanan">Layanan</a>
            </li>

            <li class="nav-item">
              <a class="nav-link" href="#harga">Harga</a>
            </li>

            <li class="nav-item">
              <a class="nav-link" href="#tentang">Tentang</a>
            </li>

            <li class="nav-item ms-lg-3 mt-3 mt-lg-0">
              <a href="https://wa.me/6283872687465?text=Halo%20saya%20ingin%20konsultasi%20jasa%20Hunter%20Cuan" class="btn btn-danger px-4">
                WhatsApp
              </a>
            </li>

          </ul>
        </div>

      </div>
    </nav>
  `;
}


function $b3225fee4c48dcf9$export$887967f05dc521ae() {
    return `
    <section class="hero text-center text-white">
      <div class="container">

        <h1 data-aos="fade-up" class="mb-3">
          Solusi Digital untuk <span class="text-danger">Bisnis Anda</span>
        </h1>

        <p data-aos="fade-up" data-aos-delay="100" class="mb-4">
          Dari percetakan hingga pembuatan website, semua kebutuhan digital Anda dalam satu tempat
        </p>

        <div data-aos="fade-up" data-aos-delay="200" class="d-flex justify-content-center flex-wrap gap-3">
          <a href="https://wa.me/6283872687465" target="_blank" class="btn btn-danger px-4">
            Konsultasi WhatsApp
          </a>

          <a href="#layanan" class="btn btn-outline-light px-4">
            Lihat Layanan
          </a>
        </div>

      </div>
    </section>
  `;
}


function $930235601d250285$export$c447b0cdbd1cd184() {
    return `
    <section id="layanan" class="section">
      <div class="container text-center">

        <h2 class="mb-3">Layanan Kami</h2>
        <p class="text-secondary mb-5">
          Solusi digital untuk kebutuhan bisnis dan personal Anda
        </p>

        <div class="row g-4">

          ${$930235601d250285$var$ServiceCard("bi-globe", "Pembuatan Website", "Landing page & web personal modern dan responsif", 0)}
          ${$930235601d250285$var$ServiceCard("bi-envelope-paper", "Undangan Digital", "Undangan web & video untuk berbagai acara", 100)}
          ${$930235601d250285$var$ServiceCard("bi-printer", "Percetakan", "Cetak banner, brosur, dan kebutuhan lainnya", 200)}
          ${$930235601d250285$var$ServiceCard("bi-mortarboard", "Instalasi CBT", "Setup ujian sekolah dengan Garuda CBT", 300)}
          ${$930235601d250285$var$ServiceCard("bi-image", "Edit Foto Vektor", "Ubah foto jadi style vector yang keren", 400)}

        </div>

      </div>
    </section>
  `;
}
function $930235601d250285$var$ServiceCard(icon, title, desc) {
    return `
    <div class="col-md-4" data-aos="fade-up" data-aos-delay="100">
      <div class="service-card p-4 h-100 text-center">

        <div class="service-icon mb-3">
          <i class="bi ${icon}"></i>
        </div>

        <h5 class="mb-2">${title}</h5>
        <p class="text-secondary small">${desc}</p>

      </div>
    </div>
  `;
}


function $9756aaa38e47f91b$export$459a29b3ff10e657() {
    return `
    <section class="section bg-dark">
      <div class="container text-center">

        <h2 class="mb-3">Kenapa Pilih Kami?</h2>
        <p class="text-secondary mb-5">
          Kami memberikan solusi terbaik untuk kebutuhan digital Anda
        </p>

        <div class="row g-4">

          ${$9756aaa38e47f91b$var$WhyItem("bi-lightning-charge", "Proses Cepat", "Pengerjaan cepat tanpa mengurangi kualitas", 0)}
          ${$9756aaa38e47f91b$var$WhyItem("bi-cash-coin", "Harga Terjangkau", "Biaya ramah untuk UMKM dan personal", 100)}
          ${$9756aaa38e47f91b$var$WhyItem("bi-gear", "Bisa Custom", "Layanan fleksibel sesuai kebutuhan Anda", 200)}
          ${$9756aaa38e47f91b$var$WhyItem("bi-headset", "Support Konsultasi", "Siap membantu dari awal sampai selesai", 300)}

        </div>

      </div>
    </section>
  `;
}
function $9756aaa38e47f91b$var$WhyItem(icon, title, desc) {
    return `
    <div class="col-md-3" data-aos="zoom-in">
      <div class="why-card p-4 text-center h-100">

        <div class="why-icon mb-3">
          <i class="bi ${icon}"></i>
        </div>

        <h6 class="mb-2">${title}</h6>
        <p class="text-secondary small">${desc}</p>

      </div>
    </div>
  `;
}


function $13048482f515b23c$export$d73ba76fbf89849b() {
    return `
    <section class="section text-center cta-section" >
      <div class="container" data-aos="fade-up">

        <h2 class="mb-3">Butuh Jasa Digital?</h2>
        <p class="text-secondary mb-4">
          Konsultasikan kebutuhan Anda sekarang, GRATIS tanpa biaya!
        </p>

        <a href="https://wa.me/6283872687465?text=Halo%20saya%20ingin%20konsultasi%20jasa%20Hunter%20Cuan" target="_blank" class="btn btn-danger btn-lg px-5">
          <i class="bi bi-whatsapp me-2"></i>
          Chat WhatsApp
        </a>

      </div>
    </section>
  `;
}


function $d5c7001fb908dd0e$export$a06f1c675e846f6f() {
    const year = new Date().getFullYear();
    return `
    <footer class="footer text-white pt-5 pb-3">
      <div class="container">

        <div class="row">

          <!-- Brand -->
          <div class="col-md-4 mb-4">
            <h5 class="mb-3">
              <span style="color:#E50914;">Hunter</span> Cuan
            </h5>
            <p class="text-secondary small">
              Solusi Digital Kreatif untuk kebutuhan bisnis dan personal Anda.
            </p>
          </div>

          <!-- Menu -->
          <div class="col-md-4 mb-4">
            <h6 class="mb-3">Menu</h6>
            <ul class="list-unstyled">
              <li><a href="#home" class="footer-link">Home</a></li>
              <li><a href="#layanan" class="footer-link">Layanan</a></li>
              <li><a href="#harga" class="footer-link">Harga</a></li>
              <li><a href="#tentang" class="footer-link">Tentang</a></li>
            </ul>
          </div>

          <!-- Kontak -->
          <div class="col-md-4 mb-4">
            <h6 class="mb-3">Kontak</h6>
            <p class="small text-secondary mb-2">
              <i class="bi bi-whatsapp me-2"></i> +6283872687465
            </p>
            <p class="small text-secondary">
              <i class="bi bi-envelope me-2"></i> hntrcuan17@gmail.com
            </p>
          </div>

        </div>

        <hr style="border-color: rgba(255,255,255,0.1);">

        <div class="text-center small text-secondary">
          \xa9 ${year} Hunter Cuan. All rights reserved.
        </div>

      </div>
    </footer>
  `;
}


function $85f1c7f22a28b271$export$9f494f8ef0034ad() {
    return `
    <a 
      href="https://wa.me/6283872687465?text=Halo%20saya%20ingin%20konsultasi%20jasa%20Hunter%20Cuan" 
      class="floating-wa" 
      target="_blank"
      aria-label="Chat on WhatsApp"
    >
      <i class="bi bi-whatsapp"></i>
    </a>
  `;
}


function $671b3a198722b6ba$export$bc75f5ddb26aac73() {
    return `
    <section id="harga" class="section text-center">
      <div class="container">

        <h2 class="mb-3">Harga Layanan</h2>
        <p class="text-secondary mb-5">
          Pilih paket sesuai kebutuhan Anda
        </p>

        <div class="row g-4">

          ${$671b3a198722b6ba$var$PriceCard("Website Basic", "Mulai dari", "Rp 500K", [
        "Landing page sederhana",
        "Desain responsif",
        "1 halaman"
    ])}

          ${$671b3a198722b6ba$var$PriceCard("Website Premium", "Mulai dari", "Rp 1.5JT", [
        "Multi halaman",
        "Custom desain",
        "Optimasi performa"
    ], true)}

          ${$671b3a198722b6ba$var$PriceCard("Undangan Digital", "Mulai dari", "Rp 100K", [
        "Undangan web / video",
        "Desain menarik",
        "Custom tema"
    ])}

        </div>

      </div>
    </section>

    ${$671b3a198722b6ba$var$OtherServices()}
  `;
}
function $671b3a198722b6ba$var$PriceCard(title, label, price, features, highlight = false) {
    const message = `Halo, saya tertarik dengan paket ${title} (${price}). Bisa minta detailnya?`;
    const encodedMessage = encodeURIComponent(message);
    const waLink = `https://wa.me/6283872687465?text=${encodedMessage}`;
    return `
    <div class="col-md-4">
      <div class="price-card p-4 h-100 ${highlight ? "highlight" : ""}">

        <h5>${title}</h5>
        <p class="text-secondary small">${label}</p>

        <h3 class="mb-3 text-danger">${price}</h3>

        <ul class="list-unstyled mb-4">
          ${features.map((f)=>`<li class="mb-2">\u{2714} ${f}</li>`).join("")}
        </ul>

        <a href="${waLink}" target="_blank" class="btn btn-danger w-100">
          Pilih Paket
        </a>

      </div>
    </div>
  `;
}
function $671b3a198722b6ba$var$OtherServices() {
    return `
    <section class="section text-center">
      <div class="container">

        <h4 class="mb-4">Layanan Lainnya</h4>

        <div class="row g-3">

          ${$671b3a198722b6ba$var$MiniPrice("Percetakan", "Mulai dari Rp 10K")}
          ${$671b3a198722b6ba$var$MiniPrice("Edit Foto Vektor", "Mulai dari Rp 25K")}
          ${$671b3a198722b6ba$var$MiniPrice("Instalasi CBT", "Mulai dari Rp 300K")}

        </div>

      </div>
    </section>
  `;
}
function $671b3a198722b6ba$var$MiniPrice(title, price) {
    return `
    <div class="col-md-4">
      <div class="mini-price p-3">
        <h6>${title}</h6>
        <p class="text-danger">${price}</p>
      </div>
    </div>
  `;
}


function $c621f8cecd50aabc$export$c8424c4d8ba2150() {
    return `
    <section id="tentang" class="section bg-dark">
      <div class="container">

        <div class="row align-items-center">

          <!-- Text -->
          <div class="col-md-6" data-aos="fade-right">
            <h2 class="mb-3">Tentang Kami</h2>

            <p class="text-secondary">
              <strong>Hunter Cuan</strong> adalah penyedia layanan digital kreatif yang fokus membantu 
              UMKM, individu, dan instansi dalam memenuhi kebutuhan digital mereka.
            </p>

            <p class="text-secondary">
              Kami menyediakan berbagai layanan mulai dari percetakan, pembuatan website, 
              undangan digital, hingga instalasi sistem ujian berbasis CBT.
            </p>

            <p class="text-secondary">
              Dengan pendekatan yang fleksibel dan harga terjangkau, kami siap membantu Anda 
              mendapatkan solusi terbaik sesuai kebutuhan.
            </p>
          </div>

          <!-- Highlight Box -->
          <div class="col-md-6 mt-4 mt-md-0" data-aos="fade-left">
            <div class="about-box p-4">

              <h5 class="mb-3">Kenapa Hunter Cuan?</h5>

              <ul class="list-unstyled text-secondary">
                <li class="mb-2">\u{2714} Layanan lengkap dalam satu tempat</li>
                <li class="mb-2">\u{2714} Harga terjangkau & fleksibel</li>
                <li class="mb-2">\u{2714} Proses cepat & responsif</li>
                <li class="mb-2">\u{2714} Bisa konsultasi sebelum order</li>
              </ul>

            </div>
          </div>

        </div>

      </div>
    </section>
  `;
}


function $2b9f921e9352ca71$export$b94310965bed44e6() {
    return `
    ${(0, $38859a0fd15e9552$export$42cfbb80f7861e77)()}
    ${(0, $b3225fee4c48dcf9$export$887967f05dc521ae)()}
    ${(0, $930235601d250285$export$c447b0cdbd1cd184)()}
    ${(0, $9756aaa38e47f91b$export$459a29b3ff10e657)()}
    ${(0, $13048482f515b23c$export$d73ba76fbf89849b)()}
    ${(0, $85f1c7f22a28b271$export$9f494f8ef0034ad)()}
    ${(0, $671b3a198722b6ba$export$bc75f5ddb26aac73)()}
    ${(0, $c621f8cecd50aabc$export$c8424c4d8ba2150)()}
    ${(0, $d5c7001fb908dd0e$export$a06f1c675e846f6f)()}
  `;
}


AOS.init({
    duration: 800,
    once: true
});
document.getElementById("app").innerHTML = (0, $2b9f921e9352ca71$export$b94310965bed44e6)();
window.addEventListener("scroll", ()=>{
    const navbar = document.querySelector(".navbar");
    if (window.scrollY > 50) navbar.classList.add("navbar-scrolled");
    else navbar.classList.remove("navbar-scrolled");
});
var $93fe0ca3e8a620dd$exports = {};
$93fe0ca3e8a620dd$exports = import.meta.resolve("7yeQP");


if ("serviceWorker" in navigator) navigator.serviceWorker.register($93fe0ca3e8a620dd$exports).then(()=>console.log("Service Worker Registered")).catch((err)=>console.log("SW failed", err));


//# sourceMappingURL=path0.61b6dc9d.js.map
